import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

const initial = () => {
  const q = new URLSearchParams(window.location.search).get("lang");
  if (q === "es" || q === "en") return q;
  return sessionStorage.getItem("bsn-lang") === "es" ? "es" : "en";
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(initial);
  useEffect(() => { localStorage.removeItem("bsn-lang"); sessionStorage.setItem("bsn-lang", lang); }, [lang]);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangToggle = ({ dark = true }) => {
  const { lang, setLang } = useLang();
  const base = "px-4 py-1.5 rounded-full text-sm font-semibold transition-colors";
  const on = "bg-bsn-gold text-bsn-midnight";
  const off = dark ? "text-bsn-ice/80 hover:text-white" : "text-bsn-midnight/70 hover:text-bsn-midnight";
  return (
    <div className={`inline-flex p-1 rounded-full border ${dark ? "border-bsn-gold/50 bg-bsn-navy/60" : "border-bsn-midnight/20 bg-white"}`} role="group" aria-label="Language" data-testid="lang-toggle">
      <button onClick={() => setLang("en")} className={`${base} ${lang === "en" ? on : off}`} data-testid="lang-en">English</button>
      <button onClick={() => setLang("es")} className={`${base} ${lang === "es" ? on : off}`} data-testid="lang-es">Español</button>
    </div>
  );
};
